import { render } from "./Supplier.vue?vue&type=template&id=b1bde376&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"

import "./Supplier.vue?vue&type=style&index=0&id=b1bde376&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1bde376"

export default script